import {
  type SizeFilterDepartment,
  type SizeFilterGroup,
  type SizeFiltersResponse,
} from './aliases';
import {
  MENSWEAR_DEPARTMENT_ID,
  WOMENSWEAR_DEPARTMENT_ID,
  KIDSWEAR_DEPARTMENT_ID,
} from './constants';

const DEPARTMENT_ORDER = [
  MENSWEAR_DEPARTMENT_ID,
  WOMENSWEAR_DEPARTMENT_ID,
  KIDSWEAR_DEPARTMENT_ID,
];

function sortDepartments(
  sizeFilterTree: SizeFiltersResponse
): SizeFiltersResponse {
  return [...sizeFilterTree].sort((a, b) => {
    const aIndex = DEPARTMENT_ORDER.indexOf(String(a.id));
    const bIndex = DEPARTMENT_ORDER.indexOf(String(b.id));
    const aOrder = aIndex === -1 ? Infinity : aIndex;
    const bOrder = bIndex === -1 ? Infinity : bIndex;
    return aOrder - bOrder;
  });
}

/**
 * Returns all sizes for a given top-level department id.
 */
function selectDepartmentSizes(
  sizeFilterTree: SizeFiltersResponse,
  departmentId: string
): SizeFilterGroup[] {
  const department = sizeFilterTree.find((node) => node.id === departmentId);

  if (!department) {
    return [];
  }

  return department.children;
}

/**
 * Selects the branch or branches of the size filter tree that map to the currently
 * applied category and subcategory filters.
 *
 * In the new tree structure, top-level nodes are departments with string IDs
 * ("menswear", "womenswear", "kidswear"). There is no longer an association
 * between groups/subcategories and size sets, so we filter only by department.
 *
 * @param sizeFilterTree Size filter tree, or partial size filter tree with any
 *                       empty sizes removed by pruning
 * @param gender
 * @param isKids
 */
export function selectBranchFromDepartment({
  sizeFilterTree,
  gender,
  isKids,
}: {
  sizeFilterTree: SizeFiltersResponse;
  gender?: string;
  isKids?: boolean;
}): SizeFilterDepartment[] | SizeFilterGroup[] {
  if (gender === 'male') {
    return selectDepartmentSizes(sizeFilterTree, MENSWEAR_DEPARTMENT_ID);
  }

  if (gender === 'female') {
    return selectDepartmentSizes(sizeFilterTree, WOMENSWEAR_DEPARTMENT_ID);
  }

  if (isKids) {
    return selectDepartmentSizes(sizeFilterTree, KIDSWEAR_DEPARTMENT_ID);
  }

  return sortDepartments(sizeFilterTree);
}
